let slideIndex = 0;
if($('.animated-text').length > 0) {
    showSlides();
} else {
    return false;
}
function showSlides() {
    let i;
    let slides = document.getElementsByClassName("variation-wrapper");
    for (i = 0; i < slides.length; i++) {
        slides[i].classList.remove("typing-effect");
    }
    slideIndex++;
    if (slideIndex > slides.length) {slideIndex = 1}
    slides[slideIndex-1].classList.add("typing-effect");
    setTimeout(showSlides, 4000); 
}

